import { useGLTF } from '@react-three/drei';
import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext, useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';

type Props = {
  pos?: Array<number>;
  index?: number;
  partNumber?: number;
};

const MapPin = ({
  pos = [0.6, 0.04, 0.3],
  index = 1,
  partNumber = 1,
}: Props) => {
  const { setPinInfo, pinInfo } = useContext(ControlContext);
  console.log('pinInfo', pinInfo);
  const meshRef = useRef<any>(null);
  const { nodes } = useGLTF('/special/pointer.glb');
  const [hover, setHover] = useState(false);
  useEffect(() => {
    if (meshRef.current) {
      if (pinInfo.index === index && pinInfo.partNumber === partNumber) {
        gsap.to(meshRef.current.scale, {
          duration: 2,
          ease: 'power2.out',
          x: 0,
          y: 0,
          z: 0,
        });
      } else {
        gsap.to(meshRef.current.scale, {
          duration: 2,
          ease: 'power2.out',
          x: 0.01,
          y: 0.01,
          z: 0.01,
        });
      }
    }
  }, [meshRef, pinInfo]);
  return (
    <mesh
      ref={meshRef}
      position={[pos[0], pos[1], pos[2]]}
      geometry={nodes.Object_2.geometry}
      scale={0}
      rotation={[-Math.PI / 2, 0, 0]}
      onPointerOver={(e) => {
        e.stopPropagation();
        setHover(true);
      }}
      onPointerLeave={(e) => {
        e.stopPropagation();
        setHover(false);
      }}
      onPointerDown={(e) => {
        e.stopPropagation();
        setPinInfo({
          index: index,
          pos: pos,
          partNumber: partNumber,
        });
      }}
    >
      <meshStandardMaterial color={hover ? 'red' : 'blue'} roughness={0} />
    </mesh>
  );
};

export default memo(MapPin);
